import type { ClienteRepresentada, TabelaPreco } from '../db/tipos'

// Decisao dela, 10/10/2026: quando o cliente tem uma tabela ESPECIFICA numa
// marca (escolhida na ficha, `tabela_preco_fixa`), no pedido so ela aparece
// daquela marca. As demais marcas seguem com todas as tabelas.
//
// Duas salvaguardas: so conta o que foi ESCOLHIDO a mao (a tabela apenas
// aprendida do ultimo pedido continua so passando na frente, sem esconder
// nada), e se a tabela fixa nao esta mais entre as disponiveis a marca volta a
// mostrar tudo -- esconder a marca inteira da busca seria pior que ignorar a regra.
export function tabelasDoClienteNoPedido(
  tabelas: TabelaPreco[],
  vinculos: ClienteRepresentada[],
): TabelaPreco[] {
  const fixaPorMarca = new Map<string, string>()
  for (const v of vinculos) {
    if (v.apagado_em !== null || !v.tabela_preco_fixa || v.tabela_preco_padrao_id === null) continue
    fixaPorMarca.set(v.representada_id, v.tabela_preco_padrao_id)
  }
  return tabelas.filter((t) => {
    const fixa = fixaPorMarca.get(t.representada_id)
    if (fixa === undefined) return true
    const fixaDisponivel = tabelas.some((x) => x.id === fixa && x.representada_id === t.representada_id)
    return !fixaDisponivel || t.id === fixa
  })
}
